<template>
  <sFormItem
    ref="input"
    class="mb-0 width-100"
    :prop="formItem || 'value'">
    <div
      class="different-price-input"
      data-qa="offer-different-price-input">
      <sInputNumber
        class="new-price-input mt-auto"
        data-qa="new_price_value"
        debounce
        :disabled="disabled"
        placeholder="0,0"
        :value.sync="text_value"
        @blur="$emit('blur', text_value)"
        @keydown_enter="$emit('blur', text_value)"
        @update:value="change"/>
      <span class="h7-text">
        {{ type == 'PRICE' ? currency : '%' }}
      </span>
    </div>
  </sFormItem>
</template>

<script>
import TextField from 'components/common/inputs/TextField.vue'
import { formItem, modalMixin } from 'mixins'

import { mapGetters } from 'vuex'

export default {
  name: 'offerDifferentPriceInput',
  mixins: [modalMixin, formItem],
  props: {
    type: [String, Number],
    value: [String, Number],
    currency: String,
    formItem: String
  },
  computed: {
    ...mapGetters({
      $_tendersSettings: 'getTendersSettings',
    }),
    disabled() {
      return this.type == 1 || this.type == 2
    },
    text_value: {
      get() {
        return this.value || 0
      },
      set(value) {
        this.$emit('update:value', value)
      }
    },
    digit() {
      if ( this.type === 'PRICE' ) {
        return this.$_tendersSettings.priceRoundingDigit || 2
      }
      return 2
    },
    inputPlaceHolder() {
      return '0.' + '0'.repeat(this.digit)
    }
  },
  methods: {
    check(text) {
      this.$set(this, 'text_value',  +this.$_formatValue(text || 0) )
      this.sliceText( text, this.$refs.new_price?.$refs?.input , this.digit,
        (val) => this.$set(this, 'text_value',  +this.$_formatValue(val || 0) ) )
    },
    clearValidate() {
      this.$refs.input.clearValidate()
    },
    change(text) {
      this.clearValidate()
      this.$emit('change', text )
    },
  },
  components: {
    TextField
  }
}
</script>
<style lang="scss" scoped>
.new-price-input {
  max-width: 150px;
}
</style>
<style lang="scss">
.different-price-input {
  display: grid;
  grid-template-columns: 150px auto;
  gap: 6px;
  align-items: center;
}
</style>
